import clsx from 'clsx';
import React from 'react';

const Modal = ({ isOpen, onClose, children, className }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className={clsx('modal md:min-w-120', className)}>
        <button
          className="close-button absolute right-4 top-2 font-semibold cursor-pointer"
          onClick={onClose}
        >
          &#x2715;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
